import { Link, useRouteError } from 'react-router';
import { Skeleton } from '../ui/misc';
import { ApiError } from '../lib/api';
import { ImpersonationBanner } from './ImpersonationBanner';

export function RouteError({ notFound }: { notFound?: boolean }) {
  const err = useRouteError() as unknown;
  const is404 = notFound || (err instanceof ApiError && err.status === 404);
  const chunk = err instanceof Error && /dynamically imported module|Loading chunk|Importing a module script failed/i.test(err.message);
  return (
    <main className="mx-auto flex min-h-[60dvh] max-w-md flex-col items-center justify-center gap-3 p-6 text-center">
      <ImpersonationBanner compact className="w-full text-left" />
      <h1 className="text-2xl font-semibold">{is404 ? 'Page not found' : chunk ? 'A new version is available' : 'Something went wrong'}</h1>
      <p className="text-muted">
        {is404 ? "It may have moved, or you don't have access to it." : chunk ? 'Reload to get the latest version.' : 'Try again. If it keeps happening, contact your team.'}
      </p>
      <div className="flex gap-2">
        <button type="button" onClick={() => window.location.reload()} className="h-11 rounded-lg border border-border bg-card px-4 font-medium">
          Reload
        </button>
        <Link to="/" className="inline-flex h-11 items-center rounded-lg bg-primary px-4 font-semibold text-primary-ink">
          Go home
        </Link>
      </div>
    </main>
  );
}

export function PageFallback({ full }: { full?: boolean }) {
  return (
    <div aria-busy="true" aria-label="Loading" className={full ? 'mx-auto max-w-3xl p-6' : 'py-2'}>
      {full && <ImpersonationBanner compact className="mb-4" />}
      <Skeleton className="mb-3 h-4 w-32" />
      <Skeleton className="mb-6 h-8 w-64" />
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
        <Skeleton className="h-24" />
      </div>
      <Skeleton className="mt-4 h-64" />
    </div>
  );
}
